export const dummyData = {
  policyCharges: [],
  portfolioSplit: [
    { type: 'AEGON SIP', risk_score: 4, cash_amount: 10000 },
    { type: '7IM', risk_score: 5, cash_amount: 12000 },
    { type: 'Aviva GIA', risk_score: 9, cash_amount: 8000 },
    { type: 'Overall', risk_score: 9, cash_amount: 15000 }
  ],
  pastPerformance: [
    {
      date: '01/05/2014',
      'First policy': 0.21,
      'Second policy': 2
    },
    {
      date: '01/06/2015',
      'First policy': 1.21,
      'Second policy': 2.5
    },
    {
      date: '01/09/2016',
      'First policy': 5,
      'Second policy': 1
    },
    {
      date: '02/02/2017',
      'First policy': 3,
      'Second policy': 2.2
    },
    {
      date: '21/06/2018',
      'First policy': 3.5,
      'Second policy': 2.8
    },
    {
      date: '24/12/2019',
      'First policy': 4,
      'Second policy': 2.2
    }
  ],
  assetAllocations: [
    { name: 'Asia Pacific Equities', Existing: 0, Recommended: 0 },
    { name: 'Emerging Markets', Existing: 0, Recommended: 0 },
    { name: 'Asia Pacific Equities', Existing: 0, Recommended: 0 },
    { name: 'Japanese Equities', Existing: 0, Recommended: 0 },
    { name: 'US Equities', Existing: 0, Recommended: 0 },
    { name: 'UK Equities', Existing: 0, Recommended: 0 },
    { name: 'Property', Existing: 0, Recommended: 0 },
    { name: 'Index Linked Gilts', Existing: 0, Recommended: 0 },
    { name: 'UK Gilts', Existing: 0, Recommended: 0 }
  ],
  totalOngoingCharges: [
    { name: 'Existing', cash_value: 10, percentage_value: 2 },
    { name: 'Recommended', cash_value: 10, percentage_value: 5 }
  ],
  pastPerformanceAggregates: [
    {
      date: '01/02/2015',
      Existing: '0',
      Recommended: '0',
      year: '01/02/2015'
    },
    {
      date: '01/02/2016',
      Existing: '0',
      Recommended: '0',
      year: '01/02/2015'
    },
    {
      date: '01/02/2017',
      Existing: '0',
      Recommended: '0',
      year: '01/02/2015'
    },
    {
      date: '01/02/2018',
      Existing: '0',
      Recommended: '0',
      year: '01/02/2015'
    },
    {
      date: '01/02/2019',
      Existing: '0',
      Recommended: '0',
      year: '01/02/2015'
    }
  ]
};
